<template>
  <div class="page_container" v-if="clickFAQ == false">
    <div class="page_inner">
      <div class="page_content">
        <!--보드> FAQ Data 리스트-->
        <div class="Tb_data_faq">
          <ul>
            <li>
              <a @click="changeFAQState">
                <h2>고야앱 사용방법 가이드</h2>
                <p class="time">2024-02-27 09:40</p>
              </a>
            </li>
            <li>
              <a @click="changeFAQState">
                <h2>알림 사용방법 가이드</h2>
                <p class="time">2024-02-20 10:25</p>
              </a>
            </li>

            <li></li>
          </ul>
          <a href="#none" class="btn_more_wrap">더보기</a>
        </div>
        <div class="nodata_com">해당 데이터가 없습니다.</div>
      </div>
    </div>
  </div>
  <FAQDetail v-if="clickFAQ == true" />
</template>

<script>
import FAQDetail from "@/components/board/sub/FAQDetail.vue";
import { mapState, mapMutations } from "vuex";

export default {
  name: "FAQ",
  components: {
    FAQDetail,
  },
  computed: {
    ...mapState("board", ["clickFAQ"]),
  },
  methods: {
    ...mapMutations("board", ["changeFAQ"]),

    changeFAQState() {
      this.changeFAQ({ state: true });
    },
  },
};
</script>
